import { SpeciesInteractor, SpeciesRequest, SpeciesStructRequest } from "../../Coordinator/Species/SpeciesInteractor"

export class SpeciesViewModel {
	private interactor: SpeciesInteractor;

	constructor() {
		this.interactor = new SpeciesInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new SpeciesRequest(
			obj["sgepdengueespecie"] ? parseInt(obj["sgepdengueespecie"]) : 0,
			obj["nome"] ? obj["nome"] : ""
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new SpeciesStructRequest(obj["sgepdengueespecie"] ? parseInt(obj["sgepdengueespecie"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}